module.exports = __webpack_public_path__ + "static/leaves-5508d6d6f399a99e5b033abd58b9a078.png";